import { render, staticRenderFns } from "./CampaignOptions.vue?vue&type=template&id=396e65f2&"
import script from "./CampaignOptions.vue?vue&type=script&lang=js&"
export * from "./CampaignOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports